﻿import * as React from 'react';
import { Container, Input, Row, Col, Button } from 'reactstrap';
import { RouteComponentProps } from 'react-router-dom';
import ContactForm from './ContactForm';
import './Contact.css';

class Contact extends React.PureComponent<{}, { isOpen: boolean }> {
    public state = {
        isOpen: false
    };

    public render() {
        return (
            <div className="contact">
                <div className="page-banner" style={{
                    backgroundImage: 'url("../img/contact-ourbrand.jpg")'
                }}>
                    <h1>Contact Us</h1>
                </div>
                <Container>
                    <Row>
                        <Col>
                            <h2>What Can We Help You With?</h2>
                            <p>Need help with a project? Contact us for a FREE estimate using the methods below:</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h4>Other Contact Methods</h4>
                        </Col>
                    </Row>
                    <Row className="other">
                        <Col md="4" sm="12" className="contact-method">
                            <a href="tel:16026896045">
                                <img alt="phone" src="../img/contact-phone-icon.png"></img>
                                <h5>Telephone</h5>
                                <p>Call us at (602) 689-6045</p>
                            </a>
                        </Col>

                        <Col md="4" sm="12" className="contact-method">
                            <a href="emailto:info@premierpressurewash.com">
                                <img alt="Email" src="../img/contact-email-icon.png"></img>
                                <h5>Email</h5>
                                <p>Email us at info@premierpressurewash.com</p>
                            </a>
                        </Col>

                        <Col md="4" sm="12" className="contact-method">
                            <a href="">
                                <img alt="messenger" src="../img/contact-messenger-icon.png"></img>
                                <h5>Message Us</h5>
                                <p>Message us on Facebook Messenger</p>
                            </a>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h4>Recommended Method</h4>
                            <p>Simply fill in the information below. Our trained technicans will contact you within a few hours.</p>
                        </Col>
                    </Row>
                    <Row className="online-form">
                        <Col>
                            <ContactForm></ContactForm>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
};

export default Contact;

